import { Inject, Injectable } from '@angular/core';
import { IAPProduct } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
import { CwtApiService, CwtCrudContract, CwtCrudService } from '@cawita/core-front/api';
import { MarketProvider, Product, Subscription, SubscriptionSubType } from '@shared/models';
import { lastValueFrom } from 'rxjs';
import { MarketManageSubscriptionService } from '../market-manage-subscription.service';
import { IAPMarketService } from './iap-market.service';

@Injectable({ providedIn: 'root' })
export class AppleMarketService extends IAPMarketService {

    constructor(
        private api: CwtApiService,
        private manage: MarketManageSubscriptionService,
        @Inject(CwtCrudContract.get(Product, 'as-pro')) private productCrud: CwtCrudService<Product>
    ) {
        super();
    }

    getPlatform(): CdvPurchase.Platform {
        return CdvPurchase.Platform.APPLE_APPSTORE;
    }

    getProvider(): MarketProvider {
        return MarketProvider.Apple;
    }

    getProducts(): Promise<Product[]> {
        return lastValueFrom(this.productCrud.getArray({ appleProduct: { ne: null } }));
    }

    getProductSKU(product: Product): string {
        return product?.appleProduct?.productId;
    }

    overridePrice(product: Product, iapProduct: CdvPurchase.Product): void {
        product.appleProduct.currency = iapProduct.pricing.currency;
        product.appleProduct.amount = iapProduct.pricing.priceMicros / 10_000;
    }

    async getReceipt(transaction: CdvPurchase.Transaction) {
        const adapter = this._store.getAdapter(this.getPlatform());
        const body = await adapter.receiptValidationBody(transaction.parentReceipt);
        const receiptTransaction = body.transaction;
        if (receiptTransaction.type !== CdvPurchase.Platform.APPLE_APPSTORE) return;
        return receiptTransaction.appStoreReceipt;
    }

    async registerSubscription(product: Product, receipt: any): Promise<void> {
        await lastValueFrom(this.api.post(`apple/subscription/success`, { receipt }));
    }

    async manageSubscription(sub: Subscription): Promise<void> {
        if (sub.subType === SubscriptionSubType.Apple) return this.manage.manageImplicitIAP();
        if (sub.subType === SubscriptionSubType.Google) return this.manage.manageGoogle();
        if (sub.subType === SubscriptionSubType.Stripe) return this.manage.manageStripe();
        return;
    }
}